export enum AutocompleteLabelPosition {
  above = 'above',
  inside = 'inside',
  hide = 'hide',
}

export enum AutocompleteSuggestionSource {
  search = 'search',
  history = 'history',
  commonsearches = 'commonsearches',
}

export enum Panels {
  none = 'none',
  history = 'history',
  suggestions = 'suggestions',
  noresults = 'noresults',
  errormessage = 'errormessage',
}
